<script>
export default {
    name: 'footer',

    computed:
    {
        productLink()
        {
            return `https://justfitart.com/fibofever/?add_product=247`
        }
    },
}
</script>

<template lang="pug">
    .justfit-footer.text-center
        .my-1
            a(href="tel:+36706669988") +36-70-666-9988
        .my-1
            a(href="mailto:info@justfitart.com") info@justfitart.com
        p.my-1 Copyright © 2019 Justfit Technology LLC
        .mt-5
            a.blueinho(:href="productLink" target="_blank") {{ $t('BASE.LINK_TO_PRODUCT') }}
</template>

<style lang="scss">
    @import "../../assets/styles/settings/settings";

    .justfit-footer {
        background-color: $black;
        padding: rem(50) rem(16);
        color: #858484;
        font-size: 14px;
        a {
            color: #858484;
            &.blueinho {
                color: #117870;
            }
        }
    }
</style>
